module.exports = function (d, b) {
	for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	function __() { this.constructor = d; }
	d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


//////////////////
// WEBPACK FOOTER
// ./sources/utils/extends.js
// module id = 5
// module chunks = 0